import { Moment } from 'moment';

export class BufferChangeReason {
    constructor(
        public readonly date: Moment,
        public readonly reason: string,
        public readonly supplier: string,
        public readonly lastOrderDate: string,
        public readonly planDeliveryDate: string,
        public readonly deliveryDate: string,
        public readonly docInputDate: string,
        public readonly initialOrder: string,
        public readonly sentOrder: string,
        public readonly arrivedOrder: string,
        public readonly orderSchedule: string
    ) { }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/buffer-change-reasons/buffer-change-reason.ts